function ConvertirStringHTML(cadenaInicial, className) {
    //console.log(cadenaInicial.toLowerCase())
    const textoPrueba = cadenaInicial;
    const textoFinal = textoPrueba.split('<br>')

    return (
        <p className={className}>
            {
                textoFinal.map((item, index) => {

                    return (
                        <span className="d-block" key={index}> {item} </span>
                    )
                })
            }
        </p>
        
    )
}

export default ConvertirStringHTML;